import AssessmentSummary from './AssessmentSummary'
import SurveyCompletion from './SurveyCompletion'
import AssessmentByMonth from './AssessmentByMonth'
import RoundProgress from './RoundProgress'
import PatAchievementBands from './PatAchievementBands'
import PatScoreTrend from './PatScoreTrend'
import PatMathsVsReading from './PatMathsVsReading'
import PatCoverage from './PatCoverage'
import PatStudentReport from './PatStudentReport'
import PatItemCohort from './PatItemCohort'
import PeriodicalReportChart from './PeriodicalReportChart'
import StudentSummaryReport from './StudentSummaryReport'

const CHART_MAP = {
  AssessmentSummary,
  SurveyCompletion,
  AssessmentByMonth,
  RoundProgress,
  PatAchievementBands,
  PatScoreTrend,
  PatMathsVsReading,
  PatCoverage,
  PatStudentReport,
  PatItemCohort,
  PeriodicalReportChart,
  StudentSummaryReport
}

const BiChartRenderer = ({ link }) => {
  const Chart = CHART_MAP[link]
  if (!Chart) {
    return (
      <div style={{ padding: 24, color: '#888' }}>
        Unknown BI chart: <strong>{link}</strong>
      </div>
    )
  }
  return <Chart />
}

export default BiChartRenderer
